import { useState, useEffect } from "react";
export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    if (typeof window !== "undefined") {
      function handleResize() {
        setWindowSize({
          width: window.document.documentElement.offsetWidth,
          height: window.document.documentElement.offsetHeight,
        });
      }
      window.addEventListener("resize", handleResize);
      setTimeout(() => {
        handleResize();
      }, 1000); // Set timeout to wait WP content loaded
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);
  return windowSize;
}
